import {
	postUsersIdUploadAvatar,
	type UserAvatarUploadDto,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { USER_PROFILE } from "Settings/User/Api/Query/useUserProfileQuery";
import { userAvatarVersionAtom } from "Settings/User/Atom/userAvatarVersionAtom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAtom } from "jotai";
import { toast } from "sonner";

const userMutationResource = Resources.base.user.mutations;

export const useUploadUserAvatarMutation = (userId: number) => {
	const { t } = useResource();
	const queryClient = useQueryClient();
	const [userAvatarVersion, setUserAvatarVersion] = useAtom(
		userAvatarVersionAtom,
	);

	return useMutation({
		mutationFn: processResponse((data: UserAvatarUploadDto) =>
			postUsersIdUploadAvatar(data, userId),
		),
		onError: (error) => {
			console.error(`${t(userMutationResource.userUploadAvatarError)}:`, error);
		},
		onSuccess: () => {
			toast.success(t(userMutationResource.userUploadAvatarSuccess));
			setUserAvatarVersion(userAvatarVersion + 1);
			queryClient.invalidateQueries({
				queryKey: [USER_PROFILE],
			});
		},
	});
};
